'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnSuppportedWalletModal = function UnSuppportedWalletModal(_ref) {
  var walletType = _ref.walletType,
      onBack = _ref.onBack,
      appName = _ref.appName;

  var content = null;
  // No web3 found in browser.
  if (walletType === 'browser') {
    content = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h2',
        null,
        'Install MetaMask'
      ),
      _react2.default.createElement(
        'p',
        null,
        'To start using ',
        appName,
        ' you will need to use a browser linked digital wallet service, such as ',
        _react2.default.createElement(
          'span',
          null,
          'MetaMask'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'actions' },
        _react2.default.createElement(
          'button',
          { className: 'btn cancel', name: 'back', onClick: onBack },
          'Back'
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'btn',
            name: 'install',
            onClick: function onClick() {
              document.location.href = 'https://metamask.io/';
            }
          },
          'Install MetaMask'
        )
      )
    );
  }
  // Browser doesn't support U2F protocol needed for wallet communication.
  if (walletType === 'ledger') {
    content = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        null,
        'Your browser does not support Hardware Wallet communication.'
      ),
      _react2.default.createElement(
        'p',
        null,
        'You will need to install/use the desktop version of',
        ' ',
        _react2.default.createElement(
          'a',
          { href: 'https://www.google.com/chrome/', target: '_blank', rel: 'noopener noreferrer' },
          'Chrome'
        ),
        ' ',
        'to use ',
        appName,
        '.'
      ),
      _react2.default.createElement(
        'div',
        { className: 'actions' },
        _react2.default.createElement(
          'button',
          { name: 'back', className: 'btn cancel', type: 'button', onClick: onBack },
          'Back'
        )
      )
    );
  }
  return _react2.default.createElement(
    'div',
    { className: 'un-supported-wallet-modal' },
    content
  );
};

UnSuppportedWalletModal.defaultProps = {
  onBack: function onBack() {
    return null;
  },
  appName: 'the app'
};

UnSuppportedWalletModal.propTypes = {
  walletType: _propTypes2.default.string.isRequired,
  onBack: _propTypes2.default.func,
  appName: _propTypes2.default.string
};

exports.default = UnSuppportedWalletModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/UnSuppportedWalletModal.js
// module id = 1142
// module chunks = 0